// extracted by mini-css-extract-plugin
module.exports = {"HeaderTitle":"Header_HeaderTitle__1BnSO","HeaderTitleAdmin":"Header_HeaderTitleAdmin__YENO5"};